<div class="p-grid">
  <div class="p-col-7">
    <p-scrollpanel [style]="{ width: '100%', height: '84vh' }">
      <p-panel header="Crew & Equipment" [toggleable]="true" [collapsed]="true" class="topHeader">
        <app-crews-and-equipment-panel [selectedView]='selectedView' [canDrag]="canEdit"></app-crews-and-equipment-panel>
      </p-panel>
      <p-panel header="Work Orders" [toggleable]="true" class="topHeader">
        @if (calendarComponent) {
        <app-work-orders-panel [selectedView]='selectedView' [isTreeWorkOnly]="true"
          (taskDraggedStartEvent)="taskDragStart($event)" (taskDraggedEndEvent)="taskDragEnd()"
          (dragStartEvent)="woDragStart($event)" (dragEndEvent)="clearGrayOverlayOnBuckets()" [canDrag]="canEdit"></app-work-orders-panel>
        }
      </p-panel>
    </p-scrollpanel>
  </div>
  <div class="p-col-5">
    <p-scrollpanel [style]="{width: '100%', height: '84vh'}">
      <div style="height: 100%">
        <app-two-day-calendar-view (woDragged)="onWoDragged($event)" (woDraggedEnd)="onWoDraggedEnd()"
          (taskDragged)="taskDragStart($event)" (taskDraggedEnd)="taskDragEnd()" [isWork]="true" [canDrag]="canEdit"
          [isWellness]="false"></app-two-day-calendar-view>
      </div>
    </p-scrollpanel>
  </div>
</div>